import { FormEvent, useState } from "react";
import { Link, useLoaderData, useNavigate, useSearchParams, useSubmit } from "react-router-dom";

import Modal from "src/components/common/Modal";
import MyCKEditor from "src/components/common/myCKEditor";
import { useAuthStore, User } from "src/components/main/authStore";

import { ArticleLoaderData, NEWSPAPER_ROOT_ID } from "./actions_loaders";

export default function NewspaperForm({
    keyword,
}: {
    keyword: "Add" | "Edit" | "View";
}) {
    const currentUser = useAuthStore(state => state.user) as User;
    const navigate = useNavigate();
    const submit = useSubmit();
    const [searchParams] = useSearchParams();
    const articleLoader = useLoaderData() as ArticleLoaderData | undefined;
    const folderId = searchParams.get("folderId") || articleLoader?.folderId || NEWSPAPER_ROOT_ID;
    const backTo = folderId !== NEWSPAPER_ROOT_ID ? `/Newspaper/${folderId}` : "/Newspaper";
    const [name, setName] = useState(articleLoader?.article.name ?? "");
    const [data, setData] = useState(articleLoader?.article.data ?? "");
    const canEdit = currentUser.newspaper === "edit";
    const readOnly = keyword === "View" || !canEdit;

    return (
        <Modal
            max
            closeIt = {() => navigate(backTo)}
            title = {keyword === "View" ? (name || "View") : keyword}
            width = {"900px"}
            handleFormSubmit = {readOnly ? undefined : (e: FormEvent<HTMLFormElement>) => {
                submit(e.currentTarget, { method: "post" });
            }}
            actionKey = {readOnly ? undefined : keyword}
        >
            <input type = "hidden" name = "action" value = {keyword === "View" ? "Edit" : keyword} />
            <input type = "hidden" name = "rootFolderId" value = {NEWSPAPER_ROOT_ID} />
            <input type = "hidden" name = "parentFolderId" value = {folderId} />
            <input type = "hidden" name = "fileId" value = {articleLoader?.article.id ?? ""} />
            <input type = "hidden" name = "data" value = {data} />
            {!readOnly ? (
                <div className = "my-3 d-flex align-items-center">
                    <span className = "me-3 fw-bold">Title</span>
                    <input
                        required
                        className = "form-control d-block flex-grow-1"
                        name = "subject"
                        value = {name}
                        onChange = {e => setName(e.currentTarget.value)}
                    />
                </div>
            ) : null}
            <div className = "my-3">
                <MyCKEditor
                    data = {data}
                    onChange = {(e: unknown, editor: { getData: () => string }) => {
                        setData(editor.getData());
                    }}
                    disabled = {readOnly}
                />
            </div>
            <div className = "my-3">
                <Link to = {backTo} className = "btn btn-outline-secondary float-end">Back</Link>
            </div>
        </Modal>
    );
}
